var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-layout',[_c('v-flex',[_c('v-toolbar',{attrs:{"color":"white","dark":"","flat":"","dense":"","cad":""}},[_c('v-toolbar-title',{staticClass:"indigo--text"},[_vm._v("Recepción de Materiales")])],1)],1)],1),_c('grid-recepcion',{key:_vm.recepcionGrid,attrs:{"contratoId":_vm.contratoId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }